import React from 'react';
import { useIntl } from 'react-intl';
import TFFButton from '../../../../styled-components/TFFButton';

interface NdcSearchFooterProps {
  rebookCloser: (value: boolean) => void;
  handleRequest: () => Promise<void>;
  cancelHandler: () => void;
}

const NdcSearchFooter: React.FC<NdcSearchFooterProps> = ({ rebookCloser, handleRequest, cancelHandler }) => {
  const intl = useIntl();

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '25px' }}>
      <TFFButton
        buttonText={intl.formatMessage({ id: 'ndc.rebookCancel' })}
        variant="secondary"
        outline
        handleClick={() => {
          rebookCloser(false);
          cancelHandler();
        }}
      />
      <TFFButton
        buttonText={intl.formatMessage({ id: 'rebook.searchAlternatives' })}
        variant="primary"
        handleClick={() => handleRequest()}
      />
    </div>
  );
};

export default NdcSearchFooter;
